var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavGtm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4438 4.17394H21.4663C21.075 4.17394 20.7576 4.49134 20.7576 4.88269V9.70144H17.1976V1.53675C17.1976 1.14541 16.8802 0.828003 16.4888 0.828003H11.5113C11.12 0.828003 10.8026 1.14541 10.8026 1.53675V14.9478H7.24258V8.92326C7.24258 8.53179 6.92518 8.21451 6.53383 8.21451H1.55641C1.16494 8.21451 0.847656 8.53179 0.847656 8.92326V22.4914C0.847656 22.8829 1.16506 23.2002 1.55641 23.2002H6.53383H11.5113H16.4888H21.4663H26.4437C26.8352 23.2002 27.1524 22.8827 27.1524 22.4914V4.88269C27.1525 4.49134 26.8352 4.17394 26.4438 4.17394ZM5.82514 21.7827H2.26516V9.63201H5.82514V21.7827ZM10.8027 21.7827H7.2427V16.3653H10.8027V21.7827ZM15.7802 10.4102V21.7827H12.2201V2.2455H15.7802V10.4102ZM20.7577 21.7827H17.1977V11.1189H20.7577V21.7827ZM25.7351 21.7827H22.1752V10.4102V5.59144H25.7352V21.7827H25.7351Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavGtm);
export default __webpack_public_path__ + "static/media/nav_gtm.329d9a690886206d1eb7ee8df5fea6bb.svg";
export { ForwardRef as ReactComponent };